<template>
  <footer class="foot">
    <div class="w1200">
      <div class="top">
        <ul class="wow fadeInRight" id="footer_top">
          <li v-for="(item, index) in topList.nav" :key="index">
            <a :href="item.Url">
              <p>{{ item.Name }}</p>
            </a>
          </li>
        </ul>
      </div>
      <div class="flexDiv">
        <div class="left wow fadeInLeft">
          <p><img :src="LogoList.Logo" alt="" /></p>
          <ul>
            <li>地址：南京市江宁区铜山金铜路2号</li>
            <li>
              电话：400 809
              9055&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;招生办邮箱：zsb@jku.cn
            </li>
            <li>Coyright © 金肯职业技术学院 All rights reserved.</li>
            <li>
              <a
                href="https://beian.miit.gov.cn/"
                style="color: white; display: inline-block"
                target="_blank"
                >苏ICP备11073940号-1&nbsp;苏公网安备 32011502010881号</a
              >
            </li>
          </ul>
        </div>
        <div class="right">
          <ul class="flexDiv wow fadeInRight" id="footer_ewm">
            <li v-for="(item, index) in Qcode" :key="index">
              <p><img :src="item.FileUrl" alt="" /></p>
              <span>{{ item.Title }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Foote",
  topList: {
    type: Array,
    default: () => [],
  },
  moreLink: {
    type: String,
    default: "",
  },
  styles: {
    type: Object,
    default: () => {
      return {
        width: 1920,
        height: 500,
      };
    },
  },
  data() {
    return {
      LogoList: [],
      Qcode: [],
    };
  },
  created() {
    this.LogoList = this.Base.GetDepartmentByDid(260);
    this.topList = this.Base.GetFNavColumnsByCid(6580, "", "", "footer_top"); //topList
    // console.log(this.topList.nav);
    this.Qcode = this.Base.GetFilesInfoByCid(5197, 1, "", 20, 1); //qcode
    //  console.log(this.Qcode)
  },
};
</script>
<style lang="less" scoped>
.foot {
  width: 100%;
  height: 335px;
  box-sizing: border-box;
  background-color: #0376be;
  .w1200 {
    .top {
      width: 100%;
      height: 50px;
      ul {
        padding-top: 10px;
        height: 20px;
        display: flex;
        flex-flow: nowrap;
        justify-content: center;
        li {
          padding-left: 20px;
          padding-right: 21px;
          border-left: solid 1px #ffffff;
          &:first-child {
            border-left: none;
          }
          &:hover {
            a {
              p {
                color: #74f4ff;
              }
            }
          }
          a {
            p {
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 1px;
              color: #ffffff;
            }
          }
        }
      }
    }
    .left {
      margin: 0;
      p {
        display: block;
        width: 387px;
        height: 73px;
        margin: 0;
        padding-top: 27px;
        margin-bottom: 20px;
        img {
          display: block;
          object-fit: contain;
          margin: 0;
        }
      }
      li {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 28px;
        letter-spacing: 2px;
        color: #ffffff;
      }
    }
    .right {
      margin: 0;
      margin-top: 48px;
      ul {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        p {
          width: 129px;
          height: 129px;
        }
        li {
          margin-left: 42px;
        }
        span {
          text-align: center;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 2px;
          color: #ffffff;
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Foote.vue